export default __webpack_public_path__ + "static/media/cta-bg.1b3c3f5c.jpg";